import {
  IGuardianLeaveRecord,
  IGuardianLeaveStatsResponse,
} from '../../apis/guardian/guardianLeaves.interfaces';

export const mockGuardianLeaveStats: IGuardianLeaveStatsResponse = {
  stats: [
    { leaveTypeId: 'lt-1', leaveTypeName: 'Public Holiday', leaveTypeCode: 'public', available: 10, taken: 0 },
    { leaveTypeId: 'lt-2', leaveTypeName: 'Optional Vacation', leaveTypeCode: 'optional_vacation', available: 8, taken: 2 },
    { leaveTypeId: 'lt-3', leaveTypeName: 'Sick Leave', leaveTypeCode: 'sick', available: 10, taken: 1 },
    { leaveTypeId: 'lt-4', leaveTypeName: 'Paid Leave', leaveTypeCode: 'paid', available: 15, taken: 3 },
  ],
};

export const mockGuardianLeaveList: IGuardianLeaveRecord[] = [
  {
    id: 'gleave-1',
    leaveTypeId: 'lt-2',
    leaveTypeName: 'Optional Vacation',
    leaveTypeCode: 'optional_vacation',
    startDate: '2025-02-10',
    endDate: '2025-02-11',
    status: 'approved',
    reason: 'Parent-teacher meeting',
    appliedAt: '2025-02-05T10:00:00Z',
  },
];
